export default __webpack_public_path__ + "static/media/avocado-list-icon.267b6b5d.svg";